/**
 * Port-to-adapter bindings — env-driven.
 *
 * DEFAULTS = "mock" for every category that talks to the outside world.
 * This is a constitutional decision: Commercial Operator V0.01 must run
 * fully without API keys or external services. Real adapters are
 * activated one at a time by flipping an env var.
 *
 *   REACT_APP_STORAGE_ADAPTER      = memory | http | mongodb | postgres | supabase
 *   REACT_APP_CRM_ADAPTER          = mock  | none | ghl | hubspot | salesforce
 *   REACT_APP_MESSAGING_ADAPTER    = mock  | none | whatsapp | sms | email
 *   REACT_APP_LLM_ADAPTER          = templates | claude | gemini | openai
 *   REACT_APP_KNOWLEDGE_ADAPTER    = mock  | none | mcp
 *   REACT_APP_CALENDAR_ADAPTER     = mock  | none | google | outlook | calendly
 *   REACT_APP_ERP_ADAPTER          = mock  | none | odoo | dynamics | sap
 */
const env = (name, fallback) => process.env[name] || fallback;

export const PORTS_CONFIG = {
  storage: env("REACT_APP_STORAGE_ADAPTER", "memory"),
  crm: env("REACT_APP_CRM_ADAPTER", "mock"),
  messaging: env("REACT_APP_MESSAGING_ADAPTER", "mock"),
  llm: env("REACT_APP_LLM_ADAPTER", "templates"),
  knowledge: env("REACT_APP_KNOWLEDGE_ADAPTER", "mock"),
  calendar: env("REACT_APP_CALENDAR_ADAPTER", "mock"),
  erp: env("REACT_APP_ERP_ADAPTER", "mock"),
};
